import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {KeycloakService} from "keycloak-angular";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isAuthenticated$ = new BehaviorSubject<boolean>(false);
  userInfo$ = new BehaviorSubject<any>(null);

  constructor(private keycloakService: KeycloakService) {
    this.keycloakService.isLoggedIn().then((logged) => {
      this.isAuthenticated$.next(logged);
      if (logged) {
        this.keycloakService.loadUserProfile().then((user) => {
          this.userInfo$.next(user);
        })
      }
    })
  }
}
